module.exports = __webpack_public_path__ + "static/media/worldIcon.0a042716.svg";